import CopySvg from '@assets/images/svg/copy.svg';
import React from 'react';
import { View } from 'react-native';

export interface CopyIconProps {
    size?: number;
    color?: string;
}

export function CopyIcon({ size = 20, color = '#333333' }: CopyIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CopySvg width={size} height={size} color={color} />
        </View>
    );
}